// @ts-nocheck
import { call, crud, download, downloadBlob } from '../shared/utils/api';

export const api = {
  custom: (options: any) => call(options.url, options.method, options),
  onBoarding: {
    stripe: (options: any) => call('/private_api/onboarding/stripe', 'POST', options),
    noPayment: (options: any) => call('/private_api/onboarding/no_payment', 'POST', options),
    codaboxToken: (options: any) => call('/private_api/onboarding/codabox', 'POST', options),
    codaboxRequest: (options: any) =>
      call('/private_api/onboarding/codabox/request_token', 'POST', options),
    ponto: (options: any) => call('/private_api/onboarding/ponto', 'POST', options),
    bankAccount: (options: any) =>
      call('/private_api/onboarding/company_bank_account', 'POST', options),
    debtCollectionSettings: (options: any) =>
      call('/private_api/onboarding/company_settings', 'POST', options),
    onBoardingFiles: (options: any) =>
      call('/private_api/onboarding/company_files', 'POST', {
        ...options,
        fileUpload: true,
      }),
    invoicing_settings: (options: any) =>
      call('/private_api/onboarding/invoicing_settings', 'POST', options),
    horus: (options: any) => call('/private_api/onboarding/horus', 'POST', options),
    horusFetchCompanies: (options: any) =>
      call('/private_api/onboarding/horus/fetch_companies', 'GET', options),
    teamleader: (options: any) => call('/private_api/onboarding/teamleader', 'POST', options),
    exact: (options: any) => call('/private_api/onboarding/exact', 'POST', options),
    exactFetchCompanies: (options: any) =>
      call('/private_api/onboarding/exact/fetch_companies', 'GET', options),
    yuki: (options: any) => call('/private_api/onboarding/yuki', 'POST', options),
    twikey: (options: any) => call('/private_api/onboarding/twikey', 'POST', options),
    uploadTerms: (options: any) =>
      call('/private_api/onboarding/terms_and_conditions_files', 'POST', options),
  },
  settings: {
    constants: (options: any) => call('/private_api/constants', 'GET', options),
    fetchAddress: (options: any) => call('/private_api/fetch_address', 'POST', options),
    updateYukiSettings: (options: any) => call('/private_api/yuki_configurations', 'PUT', options),
    updateHorusSettings: (options: any) =>
      call('/private_api/horus_configurations', 'PUT', options),
    updateDbasicsSettings: (options: any) =>
      call('/private_api/dbasics_configurations', 'PUT', options),
    addTwikey: (options: any) => call('/private_api/billing/twikey', 'POST', options),
    updateTeamleaderSettings: (options: any) =>
      call('/private_api/teamleader_configurations', 'PUT', options),
    updateExactSettings: (options: any) =>
      call('/private_api/exact_configurations', 'PUT', options),
    exactFetchCompanies: (options: any) =>
      call('/private_api/exact_configurations/fetch_companies', 'GET', options),
    horusFetchCompanies: (options: any) =>
      call('/private_api/horus_configurations/fetch_companies', 'GET', options),
    codaboxToken: (options: any) => call('/private_api/codabox', 'POST', options),
    codaboxRequest: (options: any) => call('/private_api/codabox/request_token', 'POST', options),
    ponto: (options: any) => call('/private_api/ponto', 'POST', options),
    setDigitealConfiguration: (options: any) =>
      call('/private_api/digiteal_configurations', 'PUT', options),
    getDigitealCGV: (options: any) => call('/private_api/digiteal_tos', 'GET', options),
    syncIntegration: (options: any) =>
      call('/private_api/accounting_synchronization', 'POST', options),
    syncIntegrationPdfs: (options: any) =>
      call('/private_api/accounting_synchronization/synchronize_pdfs', 'POST', options),
  },
  session: {
    login: (options: any) => call('/auth/sign_in', 'POST', options),
    logout: (options: any) => call('/auth/sign_out', 'DELETE', options),
    resetPassword: (options: any) => call('/auth/password', 'POST', options),
    getTokenToResetPassword: (options: any) =>
      call('/auth/password/edit?config=default', 'GET', options),
    editPassword: (options: any) => call('/auth/password', 'PUT', options),
  },
  company: {
    getTerms: (options: any) =>
      downloadBlob(
        `/private_api/company_configurations/terms_and_conditions_files?=${options.id}`,
        'POST',
        options,
      ),
  },
  signup: {
    info: (options: any) => call('/auth/invitation', 'PUT', options),
  },
  activity: {
    list: (options: any) => call('/private_api/activities', 'GET', options),
    detail: (options: any) => call(`/private_api/activities/${options.id}`, 'GET', options),
    markAsRead: (options: any) =>
      call(`/private_api/activities/${options.id}/mark_as_read`, 'POST', options),
    markAllAsRead: (options: any) => call('/private_api/activities/mark_as_read', 'POST', options),
  },
  client: {
    ...crud('/private_api/debtors'),
    addComment: (options: any) =>
      call(`/private_api/debtors/${options.id}/comments`, 'POST', options),
    assignToAccManager: (options: any) =>
      call(`/private_api/debtors/${options.id}/assign_debtor`, 'POST', options),
    assignMultipleToUser: (options: any) =>
      call('/private_api/debtors/assign_debtors', 'POST', options),
    getFinancialData: (options: any) =>
      call(`/private_api/debtors/${options.id}/balance_detail`, 'GET', options),
    deleteMultiple: (options: any) =>
      call('/private_api/debtors/destroy_multiple', 'POST', options),
    pauseMultiple: (options: any) => call('/private_api/debtors/pause_debtors', 'POST', options),
    batchAction: (options: any) => call('/private_api/debtors/batch', 'POST', options),
    import: {
      getAllToConfirm: (options: any) => call('/private_api/import_debtors', 'GET', options),
      getToConfirm: (options: any) =>
        call(`/private_api/import_debtors/${options.id}`, 'GET', options),
      validateAll: (options: any) => call('/private_api/import_debtors', 'PUT', options),
      deleteToConfirm: (options: any) =>
        call(`/private_api/import_debtors/${options.id}`, 'DELETE', options),
    },
  },
  transactions: {
    getReconciliation: (options: any) => call('/private_api/manual_reconciliation', 'GET', options),
    manualReconciliation: (options: any) =>
      call('/private_api/manual_reconciliation', 'POST', options),
    payment: (options: any) => call('/private_api/payments', 'GET', options),
    ignorePayments: (options: any) => call('/private_api/payments/ignore', 'POST', options),
    unignorePayments: (options: any) => call('/private_api/payments/unignore', 'POST', options),
    unmatchManualPayment: (options: any) =>
      call(`/private_api/unmatch_manual_payments/${options.id}`, 'PUT', options),
    unmatchExternalPayment: (options: any) =>
      call(`/private_api/unmatch_external_payments/${options.id}`, 'PUT', options),
  },
  creditNote: {
    ...crud('/private_api/credit_notes'),
    send: (options: any) =>
      call(`/private_api/credit_notes/${options.id}/send_credit_note_to_debtor`, 'POST', options),
    activity: (options: any) =>
      call(`/private_api/invoices/${options.id}/activities`, 'GET', options),
    settle: (options: any) =>
      call(`/private_api/credit_notes/${options.id}/credit_note_settlement`, 'POST', options),
    batchAction: (options: any) => call('/private_api/credit_notes/batch', 'POST', options),
    invoiceSearch: (options: any) => call('/private_api/credit_note/invoices', 'GET', options),
    updateOriginalFile: (options: any) =>
      call(`/private_api/credit_notes/${options.id}/update_pdf`, 'PUT', options),
    deleteOriginalFile: (options: any) =>
      call(`/private_api/credit_notes/${options.id}/delete_pdf`, 'PUT', options),
  },
  invoice: {
    ...crud('/private_api/invoices'),
    deleteMultiple: (options: any) =>
      call('/private_api/invoices/destroy_multiple', 'POST', options),
    import: {
      ubl: (options: any) => call('/private_api/ubl', 'POST', options),
      pdf: (options: any) => call('/private_api/invoice_with_pdf', 'POST', options),
      csv: (options: any) => call('/private_api/import_invoices', 'POST', options),
      getAllToConfirm: (options: any) => call('/private_api/import_invoices', 'GET', options),
      getToConfirm: (options: any) =>
        call(`/private_api/import_invoices/${options.id}`, 'GET', options),
      validateAll: (options: any) => call('/private_api/import_invoices', 'PUT', options),
      deleteToConfirm: (options: any) =>
        call(`/private_api/import_invoices/${options.id}`, 'DELETE', options),
    },
    additionalFile: {
      detail: (options: any) =>
        call(`/private_api/invoices/${options.id}/additional_files`, 'GET', options),
      add: (options: any) => call('/private_api/additional_files', 'POST', options),
      delete: (options: any) =>
        call(`/private_api/additional_files/${options.id}`, 'DELETE', options),
    },
    debtorReaction: {
      qrCode: (options: any) => call(`/private_api/invoices/${options.id}/qr_code`, 'GET', options),
      getUnpaid: (options: any) =>
        call(`/private_api/invoices/${options.id}/debtor_reaction_balance`, 'GET', options),
      comment: (options: any) =>
        call(`/private_api/invoices/${options.id}/debtor_reaction`, 'POST', options),
      getInvoices: (options: any) =>
        call(`/private_api/invoices/${options.id}/debtor_invoices`, 'GET', options),
      getCreditNotes: (options: any) =>
        call(`/private_api/invoices/${options.id}/debtor_credit_notes`, 'GET', options),
      getGroupedInvoicePaymentInfo: (options: any) =>
        call(
          `/private_api/invoices/${options.id}/debtor_digiteal_grouped_payment`,
          'POST',
          options,
        ),
    },
    updateOriginalFile: (options: any) =>
      call(`/private_api/invoices/${options.id}/update_pdf`, 'PUT', options),
    deleteOriginalFile: (options: any) =>
      call(`/private_api/invoices/${options.id}/delete_pdf`, 'PUT', options),
    toHandle: (options: any) => call('/private_api/actionable_invoices', 'GET', options),
    document: (options: any) =>
      downloadBlob(`/private_api/invoices/${options.id}/invoice_document`, 'POST', options),
    previewTemplate: (options: any) =>
      call(`/private_api/invoices/${options.id}/preview_template`, 'GET', options),
    setSendingOptions: (options: any) =>
      call(`/private_api/invoices/${options.id}/sending_options`, 'PUT', options),
    publicDocument: (options: any) =>
      download(
        `/private_api/invoices/${options.id}/document?additional_file_id=${options.data.additional_file_id}&token=${options.data.token}&document_type=${options.data.document_type}`,
        'GET',
        options,
      ),
    copy: (options: any) =>
      call(`/private_api/invoices/${options.id}/invoice_copy`, 'POST', options),
    assignToAccManager: (options: any) =>
      call(`/private_api/invoices/${options.id}/assign_invoice`, 'POST', options),
    postponable: (options: any) => call('/private_api/postponable_invoices', 'GET', options),
    postpone: (options: any) =>
      call(`/private_api/invoices/${options.id}/postpone`, 'POST', options),
    forceReminder: (options: any) => call('/private_api/force_reminders', 'POST', options),
    postponeMultiple: (options: any) => call('/private_api/postponable_invoices', 'POST', options),
    activity: (options: any) =>
      call(`/private_api/invoices/${options.id}/activities`, 'GET', options),
    send: (options: any) =>
      call(`/private_api/invoices/${options.id}/send_to_debtor`, 'POST', options),
    getGroupedInvoices: (options: any) =>
      call(`/private_api/invoices/${options.id}/grouped_invoices_data`, 'GET', options),
    comment: (options: any) =>
      call(`/private_api/invoices/${options.id}/comments`, 'POST', options),
    conversationMessage: (options: any) =>
      call(`/private_api/invoice_feedback/${options.id}/conversation_message`, 'POST', options),
    addPayment: (options: any) =>
      call(`/private_api/invoices/${options.id}/manual_payments`, 'POST', options),
    // mark as
    markAsPaid: (options: any) =>
      call(`/private_api/invoices/${options.id}/mark_as_paid`, 'POST', options),
    markAsUnrecoverable: (options: any) =>
      call(`/private_api/invoices/${options.id}/mark_as_unrecoverable`, 'POST', options),
    dispute: (options: any) =>
      call(`/private_api/invoices/${options.id}/mark_as_disputed`, 'POST', options),
    pause: (options: any) =>
      call(`/private_api/invoices/${options.id}/update_pause`, 'POST', options),
    batchAction: (options: any) => call('/private_api/invoices/batch', 'POST', options),
    // Actionable apis
    ignoreLateFees: (options: any) =>
      call(`/private_api/invoices/${options.id}/ignore_late_fees`, 'POST', options),
    additionalReminder: (options: any) =>
      call(`/private_api/invoices/${options.id}/additional_reminder`, 'POST', options),
    lawyer: (options: any) => call(`/private_api/invoices/${options.id}/lawyer`, 'POST', options),
    closeLawyer: (options: any) =>
      call(`/private_api/invoices/${options.id}/lawyer/close`, 'POST', options),
    createFormalNotice: (options: any) =>
      call(`/private_api/invoices/${options.id}/formal_notice`, 'POST', options),
    bailiff: (options: any) => call(`/private_api/invoices/${options.id}/bailiff`, 'POST', options),
    closeBailiff: (options: any) =>
      call(`/private_api/invoices/${options.id}/bailiff/close`, 'POST', options),
    markAsToBeProccesed: (options: any) =>
      call(`/private_api/invoices/${options.id}/mark_as_to_be_processed`, 'POST', options),
    sendToThirdParty: (options: any) =>
      call(`/private_api/invoices/${options.id}/send_to_third_party`, 'POST', options),
  },
  template: {
    ...crud('/private_api/templates'),
  },
  recoveryPlan: {
    ...crud('/private_api/recovery_plans'),
    duplicate: (options: any) =>
      call(`/private_api/recovery_plans/${options.id}/recovery_plan_copy`, 'POST', options),
    switchPlansInvoices: (options: any) =>
      call('/private_api/recovery_plan_switch', 'POST', options),
    getPlansInvoices: (options: any) => call('/private_api/recovery_plan_switch', 'GET', options),
  },
  twikey: {
    login: (options: any) =>
      call('https://api.twikey.com/creditor', 'POST', {
        ...options,
        raw: true,
      }),
    invite: (options: any) =>
      call('https://api.twikey.com/creditor/invite', 'POST', {
        ...options,
        raw: true,
      }),
  },
  tables: {
    getViews: (options: any) => call('/private_api/views', 'GET', options),
    updateViews: (options: any) => call('/private_api/views', 'POST', options),
    getFiltersAvailable: (options: any) => call('/private_api/custom_filters', 'GET', options),
    getFiltersName: (options: any) => call('/private_api/filter_names', 'GET', options),
    export: (options: any) => call('/private_api/download_resources', 'POST', options),
  },
};

export default api;
